export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVozZavada';
export const NAME = 'VozZavadaText';
